export default {
  install(Vue) {
    Vue.prototype.$helpers = Vue.helpers = this
  },
  parsePhoneNumber(fullNumber) {
    // Remove any non-digit characters except '+'
    const cleanNumber = fullNumber.replace(/[^\d+]/g, '')

    // List of country codes from PhoneNumberInput component
    const countryCodes = ['+1', '+44', '+52', '+61', '+64']

    // Find matching country code
    const matchingCode = countryCodes.find((code) =>
      cleanNumber.startsWith(code),
    )

    if (matchingCode) {
      const nationalNumber = cleanNumber.slice(matchingCode.length)
      return {
        countryCode: matchingCode,
        nationalNumber,
      }
    }

    // Default to +1 if no match found
    return {
      countryCode: '+1',
      nationalNumber: cleanNumber.startsWith('+')
        ? cleanNumber.slice(1)
        : cleanNumber,
    }
  },
  /**
   * Pads a given ID to a specified length with the provided padding characters
   * @param {Object} options - The parameters object
   * @param {Number} options.id - The ID to be padded and converted to string
   * @param {Number} options.padAmount - The length to which the ID should be padded
   * @param {String} options.padChars - The characters used for padding
   * @returns {String} The padded ID
   */
  padIdToString({ id, padAmount, padChars }) {
    return id.toString().padStart(padAmount, padChars)
  },
}
